var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useIsFetching, useQueryClient } from '@tanstack/react-query';
import { CommonServiceApiTags } from 'common/services/api-tags';
import { useBalanceAndNotificationStore } from 'common/services/balance-and-notification-service/service-store/service-store';
import { useNotificationDrawerStore } from 'common/layouts/main-layout/service/notification-drawer-service/service-store/service-store';
import { useReadNotifications } from 'common/layouts/main-layout/service/notification-drawer-service/query';
import { notificationDrawerServiceInitializedSelector } from 'common/layouts/main-layout/service/notification-drawer-service/service-store/selectors';
import { balanceAndNotificationServiceUserHasNewNotificationsSelector, balanceAndNotificationServiceUserHasUnreadNotificationsSelector, } from 'common/services/balance-and-notification-service/service-store/selectors';
import { Box } from 'ui-kit/box';
import { Button } from 'ui-kit/button';
import { checkEqual } from 'common/helpers/checkEqual';
export var NotificationListActions = function (props) {
    var t = useTranslation().t;
    var readNotificationAction = useReadNotifications();
    var _a = useBalanceAndNotificationStore(function (state) { return ({
        setHasNewNotifications: state.setHasNewNotifications,
        setHasUnreadNotifications: state.setHasUnreadNotifications,
    }); }, checkEqual), setHasUnreadNotifications = _a.setHasUnreadNotifications, setHasNewNotifications = _a.setHasNewNotifications;
    var initialized = useNotificationDrawerStore(notificationDrawerServiceInitializedSelector);
    var loading = !!useIsFetching({ queryKey: [CommonServiceApiTags.NotificationDrawer] });
    var hasNewNotifications = useBalanceAndNotificationStore(balanceAndNotificationServiceUserHasNewNotificationsSelector);
    var hasNotReadNotifications = useBalanceAndNotificationStore(balanceAndNotificationServiceUserHasUnreadNotificationsSelector);
    var setCurrentPage = useNotificationDrawerStore(function (state) { return state.setCurrentPage; });
    var queryClient = useQueryClient();
    var handleReadAll = function () {
        readNotificationAction({ successCb: function () { return setHasUnreadNotifications(false); }, isRead: true });
    };
    var handleUpdateList = function () {
        setCurrentPage(0);
        setHasNewNotifications(false);
        queryClient.invalidateQueries({ queryKey: [CommonServiceApiTags.NotificationDrawer] });
    };
    return (_jsxs(Box, __assign({ display: "flex", justify: "space-between", px: 8 }, props, { children: [_jsx(Button, __assign({ variant: "text", disabled: !initialized || loading || !hasNotReadNotifications, onClick: handleReadAll }, { children: t('common.notificationDrawer.actions.readAll') })), hasNewNotifications && (_jsx(Button, __assign({ variant: "text", onClick: handleUpdateList }, { children: t('common.notificationDrawer.actions.updateList') })))] })));
};
